import { render, staticRenderFns } from "./tabDlg.vue?vue&type=template&id=c475e76a&scoped=true"
import script from "./tabDlg.vue?vue&type=script&lang=js"
export * from "./tabDlg.vue?vue&type=script&lang=js"
import style0 from "./tabDlg.vue?vue&type=style&index=0&id=c475e76a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c475e76a",
  null
  
)

export default component.exports